import React from 'react';
import PropTypes from 'prop-types';

import ImageWithFallback from '../../../global/components/helpers/ImageWithFallback';

const ContentModuleCard = ({
  contentModule
  , handleOpenModule
  , displayModuleDescriptions
}) => {

  const { title, summary, trailerPosterPath } = contentModule;

  const posterPath = trailerPosterPath ?
    trailerPosterPath.includes('http') ?
      trailerPosterPath : `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/visits/${trailerPosterPath}`
    : '/img/module_placeholder.png';

  return (
    <div className={`group flex flex-col rounded cursor-pointer max-w-xs mx-auto sm:m-0 hover:bg-pf-steel-100 hover:opacity-80`} onClick={handleOpenModule}>
      <div className="relative">
        <ImageWithFallback
          src={posterPath}
          alt={title}
          fallback={'/img/module_placeholder.png'}
          className="w-full h-48 object-cover rounded"
        />
        <div className="invisible group-hover:visible flex absolute top-0 bottom-0 w-full justify-center">
          <i className="fa-regular fa-circle-play text-[#7F9BB4] fa-4x my-auto"></i>
        </div>
        {posterPath === '/img/module_placeholder.png' && (
          <div className="flex absolute top-36 w-full items-center justify-center">
            <p className="text-[8px] text-pf-neutrone-500">powered by</p>
            <img src={'/img/pf-logo-new2.png'} className="h-4 w-auto" />
          </div>
        )}
      </div>
      <h3 className="text-pf-black-700 text-lg font-semibold my-2">{title}</h3>
      {summary && displayModuleDescriptions && (<p className="text-pf-black-700 text-sm">{summary}</p>)}
    </div>
  )
}

ContentModuleCard.propTypes = {
  contentModule: PropTypes.object.isRequired
  , handleOpenModule: PropTypes.func.isRequired
  , displayModuleDescriptions: PropTypes.bool
}

export default ContentModuleCard;
